@if (selectedBluePrintField) {
<div class="div-right-panel-component">
  <form #myForm="ngForm">
    <fieldset [disabled]="isReadOnly" style="border: none; padding: 0; margin: 0">
      <mat-form-field>
        <mat-label>Name (Type:{{ selectedBluePrintField.fieldType }})</mat-label>
        <input matInput #inputName maxlength="255" name="name" required (blur)="onNameBlur()" (focus)="selectName()" (keyup)="onChange()" type="text" [(ngModel)]="selectedBluePrintField.name" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Description</mat-label>
        <input matInput name="description" type="text" [(ngModel)]="selectedBluePrintField.description" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Label</mat-label>
        <input matInput name="label" type="text" [placeholder]="selectedBluePrintField.name" [(ngModel)]="selectedBluePrintField.label" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Tooltip</mat-label>
        <input matInput name="tooltip" type="text" [placeholder]="selectedBluePrintField.name" [(ngModel)]="selectedBluePrintField.tooltip" />
      </mat-form-field>

      @if (dropdownMultipleField) {
      <div class="checkbox-field">
        <mat-checkbox [(ngModel)]="dropdownMultipleField.isRequired" [checked]="dropdownMultipleField.isRequired" name="isRequired">Is required?</mat-checkbox>
      </div>
      }

      <div class="checkbox-field">
        <mat-checkbox [(ngModel)]="dropdownMultipleField.isReadOnly" [checked]="dropdownMultipleField.isReadOnly" name="fieldisReadOnly">Is read-only?</mat-checkbox>
      </div>

      @if (dropdownMultipleField) {
      <mat-form-field>
        <mat-label>Options</mat-label>
        <textarea matInput [rows]="5" [(ngModel)]="dropdownOptions" name="dropdownOptions"></textarea>
      </mat-form-field>
      }
    </fieldset>

    <div class="save-button-div" *ngIf="!isReadOnly">
      <button mat-raised-button color="primary" (click)="saveWork()" [disabled]="!myForm.form.valid || !myForm.form.dirty">Save</button>
    </div>
  </form>
</div>
}
